const translations = {
    title: 'Team Details'
};

export default translations;
